import { Component } from '@angular/core';
import { AuthService } from '@app/core/services';

@Component({ templateUrl: 'home.component.html' })
export class HomeComponent {

    constructor(private accountService: AuthService) {
       
    }
}